import { createGate } from 'effector-react';
import { createEvent } from 'effector';

export const SectorsGate = createGate();

export const MatrixProjectGate = createGate();
export const setMatrixProjectConSheetFiltersEv = createEvent();

export const downloadSectorsEv = createEvent();
